import React from 'react';

export const LoginLazy = React.lazy(() => import('./Login'));
